import { useDispatch, useSelector } from "react-redux";
import { _t } from "app/i18n/i18n";
import { useState, useRef, useEffect } from "react";
import { Button, Form } from "react-bootstrap";
import { FEEDBACK_MODAL, REDESIGN } from "redux/slices/api/initialisePreferences";
import Modal from "lib/Modal/Modal";
import { setPreference } from "pages/preferences/preferencesActions";
import { switchDesign } from "pages/preferences/parts/switchDesign";
import "./FeedbackModal.scss";

function delay(duration = 3000) {
  return new Promise((resolve) => {
    setTimeout(resolve, duration);
  });
}

export function trimString(string) {
  return string?.trim();
}

function FeedbackModal() {
  const dispatch = useDispatch();
  const formRef = useRef(null);
  const [validated, setValidated] = useState();
  const [feedbackSent, setFeedbackSent] = useState();
  const visibility = useSelector((state) => state.preferences[FEEDBACK_MODAL])[0];
  const isVisible = visibility === "true" || visibility === true;
  const [disabled, setDisabled] = useState(false);
  const isNewDesign = useSelector((state) => state.preferences[REDESIGN])[0] === "New";
  const setVisible = (value) => {
    dispatch(setPreference({ key: FEEDBACK_MODAL, value }));
  };

  const postFeedback = async (text) => {
    const url = "/research/japi/user/feedback";
    const body = JSON.stringify({
      text,
    });
    const method = "POST";
    const headers = { "Content-Type": "application/json" };

    try {
      const response = await fetch(url, {
        method,
        body,
        headers,
      });
      return {
        response,
      };
    } catch (error) {
      return {
        error,
      };
    }
  };

  const validateInput = () => {
    const form = formRef.current;
    const textArea = form[0];
    const text = trimString(textArea?.value);

    if (!text?.length) {
      setValidated(false);
      return false;
    }
    setValidated(true);
    return text;
  };

  const handleSubmit = async (e) => {
    const buttonName = e.currentTarget.name;
    const validatedText = validateInput();

    if (!validatedText) return;

    setDisabled(true);

    const result = await postFeedback(validatedText);
    const isPostSuccess = !!result.response;

    setFeedbackSent(isPostSuccess);
    await delay();
    setVisible(false);

    if (buttonName === "classic") {
      dispatch(setPreference({ key: "grp-redesign", value: "Classic" }));
      switchDesign("Classic");
    }
  };
  const invalidTextStyle = { display: validated === false ? "block" : "none" };
  const feedbackSentStyle = { display: feedbackSent === true ? "block" : "none" };
  const feedbackNotSentStyle = { display: feedbackSent === false ? "block" : "none" };

  useEffect(() => {
    if (isVisible) {
      setDisabled(false);
      setValidated();
      setFeedbackSent();
    }
  }, [isVisible]);

  return !isNewDesign ? null : (
    <Modal
      visible={isVisible}
      headerTitle={_t("We appreciate your feedback!")}
      onClickModalHeader={() => setVisible(false)}
      footerLeftButton={
        <Button variant="secondary" name="classic" onClick={handleSubmit} className="footer-button" disabled={disabled}>
          {_t("Send feedback and switch back to Classic")}
        </Button>
      }
      footerRightButton={
        <Button variant="primary" name="new" onClick={handleSubmit} className="footer-button" disabled={disabled}>
          {_t("Send feedback and stay with the New Design")}
        </Button>
      }
    >
      <Form noValidate ref={formRef}>
        <Form.Group>
          <Form.Label>{_t("Please give us your feedback.")}</Form.Label>

          <Form.Control
            as="textarea"
            maxLength={1000}
            rows={10}
            required
            placeholder={_t("Write your feedback here")}
            disabled={disabled}
          />

          <Form.Control.Feedback type="invalid" className="feedback" style={invalidTextStyle}>
            {_t("Please write your feedback.")}
          </Form.Control.Feedback>

          <Form.Control.Feedback type="invalid" className="feedback" style={feedbackNotSentStyle}>
            {_t("Feedback not sent. Something went wrong. Please try again later.")}
          </Form.Control.Feedback>

          <Form.Control.Feedback className="feedback" style={feedbackSentStyle}>
            {_t("Thank you for your feedback!")}
          </Form.Control.Feedback>
        </Form.Group>
      </Form>
    </Modal>
  );
}

export default FeedbackModal;
